var _rect, _rect2, _rect3, _circle, _rect4, _rect5, _path, _circle2, _rect6, _circle3, _path2, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _path3, _rect12, _rect13, _circle4, _path4, _circle5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatParent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 340 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 22,
    width: 130,
    height: 200,
    rx: 22,
    fill: "#FFFFFF",
    stroke: "#ECEEF2",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 38,
    width: 114,
    height: 168,
    rx: 12,
    fill: "#FAFAFE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 29,
    width: 22,
    height: 4,
    rx: 2,
    fill: "#E7E3F3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 54,
    r: 6,
    fill: "#7C5CFC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 50,
    width: 56,
    height: 7,
    rx: 3.5,
    fill: "#D8CCFD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 70,
    width: 94,
    height: 50,
    rx: 9,
    fill: "#EFEAFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122 110l14-16 10 11 8-7 18 12z",
    fill: "#C7B6FB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 86,
    r: 6,
    fill: "#C7B6FB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 128,
    width: 94,
    height: 24,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#F0EEF8",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 123,
    cy: 140,
    r: 7,
    fill: "#EFEAFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123 136.5c-1.8 0-3 1.3-3 3.1 0 2-0.8 2.5-0.8 2.5h7.6s-0.8-0.5-0.8-2.5c0-1.8-1.2-3.1-3-3.1z",
    fill: "#7C5CFC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 137,
    width: 42,
    height: 5,
    rx: 2.5,
    fill: "#E5E8EE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 160,
    width: 94,
    height: 40,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#F0EEF8",
    strokeWidth: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 184,
    width: 10,
    height: 8,
    rx: 2,
    fill: "#D8CCFD"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 178,
    width: 10,
    height: 14,
    rx: 2,
    fill: "#D8CCFD"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 172,
    width: 10,
    height: 20,
    rx: 2,
    fill: "#7C5CFC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 180,
    width: 10,
    height: 12,
    rx: 2,
    fill: "#D8CCFD"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 174,
    width: 10,
    height: 18,
    rx: 2,
    fill: "#7C5CFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M228 70 h58 a12 12 0 0 1 12 12 v18 a12 12 0 0 1 -12 12 h-30 l-12 10 v-10 h-16 a12 12 0 0 1 -12 -12 v-18 a12 12 0 0 1 12 -12 z",
    fill: "#7C5CFC"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 84,
    width: 46,
    height: 5,
    rx: 2.5,
    fill: "#FFFFFF",
    opacity: 0.92
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 95,
    width: 32,
    height: 5,
    rx: 2.5,
    fill: "#FFFFFF",
    opacity: 0.6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 40,
    r: 13,
    fill: "#7C5CFC",
    stroke: "#FFFFFF",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M214 33.5c-3 0-5 2.1-5 5.2 0 3.4-1.3 4.3-1.3 4.3h12.6s-1.3-0.9-1.3-4.3c0-3.1-2-5.2-5-5.2z",
    fill: "#FFFFFF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 46,
    r: 1.7,
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatParent);
export default __webpack_public_path__ + "static/media/feat-parent.439b2dbc6a77fa95231436abfb331539.svg";
export { ForwardRef as ReactComponent };